module.exports = __webpack_public_path__ + "static/media/Crossley Kitchen Fridge Unit (5).40504c77.jpg";